<div *ngFor="let r of related">
  <nlf-resolve-observation [id]=r></nlf-resolve-observation>
</div>